import React from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

export const CheckBox = props => {
    return (
        <FormControlLabel
            control={
                <Checkbox
                    {...props}
                    checked={props.checked}
                    onChange={props.onChange}
                    color="primary"
                />
            }
            label={props.label}
        />
    );
}

export default CheckBox;
